import {Component} from '@angular/core';
import {AbstractQuillToolbarButtonComponent} from '../abstract-quill-toolbar-button';

/**
 * Class for the RedoQuillToolbarButtonComponent
 * @class
 * @extends AbstractQuillToolbarButtonComponent
 *
 * @example
 * ```html
 * <advtech-undo-quill-toolbar-button #customButton></advtech-undo-quill-toolbar-button>
 * ```
 */
@Component({
  selector: 'advtech-redo-quill-toolbar-button',
  templateUrl: './redo-quill-toolbar-button.component.html',
})
export class RedoQuillToolbarButtonComponent extends AbstractQuillToolbarButtonComponent {

  /** @inheritdoc */
  hClick() {
    this.quill.getModule('history').redo();
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/buttons/redo-quill-toolbar-button/redo-quill-toolbar-button.component.ts